import { FromLink } from "../../../../utils/useNavigateFrom";
import Field, { DataSource } from "./Field";

class LayerField extends Field {
    field_type = "layer_field";

    backend_table = "layer";

    is_filterable(): boolean {
        return true;
    }

    layer_id?: string;

    // * set the value from one of the the objects
    set_value(datasource: DataSource): this {
        // always reset the value
        this.value = null;
        this.value = this.value_filter(datasource.layer[this.fieldname_getter], datasource);
        this.layer_id = datasource.layer?.id || undefined;
        return this;
    }

    // * render react component, can be overwritten by special fields
    display_component(): JSX.Element {

        // * Consultant should use LabelLinkField, this is a fallback for backwards compatibility
        if (this.fieldname_getter === "label" && this.layer_id) {
            return <FromLink to={`/layer/${this.layer_id}`}>{this.value}</FromLink>;
        }
        return <span className={this.get_classname()}>{this.formatted_value()}</span>;
    }


}

export default LayerField;
